export const USEFUL_LINKS_MODAL_TRANSLATIONS = {
  LINK_ERROR: "Le format du lien n'est pas correct",
  REQUIRED_ERROR: 'Ce champ est requis',
  CONFIRM_MODAL_DELETE: 'Supprimer',
  DELETE_MODAL_TEXT: 'Êtes-vous sûr de vouloir supprimer le lien ?',
};
